import { useMemo } from "react";

import { useMachine } from "@/_zustand/machine";
import { getEnvVariables } from "@/constants/getEnvVariables";
import { resolverCredencialesTransbank } from "@/lib/transbankCredenciales";

/**
 * useTransbankCredenciales(metodo)
 * Única capa que lee `getEnvVariables()` + `useMachine()` para resolver la
 * terna de credenciales de comercio Transbank ("oneclick" | "webpay").
 * Recalculado EN CADA RENDER (nunca cacheado en un ref) para que sea
 * reactivo a un cambio de máquina sin recargar la página — misma
 * justificación que useOneClickComercio.js.
 *
 * Devuelve { codeComerce, codeStore, apiKey } ("codeStore" es "" para
 * "webpay", que no lo usa).
 */
export const useTransbankCredenciales = (metodo) => {
  const { machine } = useMachine();
  const { APP_ENV, CODE_COMERCE_DEV, CODE_STORE_DEV, API_KEY_DEV, CODE_COMERCE_WEBPAY_DEV } =
    getEnvVariables();

  return useMemo(
    () =>
      resolverCredencialesTransbank({
        metodo,
        appEnv: APP_ENV,
        env: {
          codeComerceDev: CODE_COMERCE_DEV,
          codeStoreDev: CODE_STORE_DEV,
          apiKeyDev: API_KEY_DEV,
          codeComerceWebpayDev: CODE_COMERCE_WEBPAY_DEV,
        },
        machine,
      }),
    // deps acotadas a propósito a los campos de `machine` relevantes para
    // credenciales Transbank (evita recalcular en cambios de máquina que no
    // los toquen).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      metodo,
      APP_ENV,
      CODE_COMERCE_DEV,
      CODE_STORE_DEV,
      API_KEY_DEV,
      CODE_COMERCE_WEBPAY_DEV,
      machine?.oneclick_codigo_comercio,
      machine?.oneclick_codigo_tienda,
      machine?.oneclick_apikey,
      machine?.webpay_codigo_comercio,
      machine?.webpay_apikey,
    ],
  );
};
